import { render, staticRenderFns } from "./Detail-Salary.vue?vue&type=template&id=51d4b886"
import script from "./Detail-Salary.vue?vue&type=script&lang=js"
export * from "./Detail-Salary.vue?vue&type=script&lang=js"
import style0 from "./Detail-Salary.vue?vue&type=style&index=0&id=51d4b886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports